var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreferencesWizard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_885_39900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 60.0001C46.5685 60.0001 60 46.5686 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5686 13.4315 60.0001 30 60.0001Z",
    fill: "#0061611a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3844 38.0808H51.617C52.9823 38.0808 54.0815 39.18 54.0815 40.5454C54.0815 41.9107 52.9823 43.01 51.617 43.01H11.3844C10.0191 43.01 8.91992 41.9107 8.91992 40.5454C8.91992 39.18 10.0191 38.0808 11.3844 38.0808Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3844 20.7124H51.617C52.9823 20.7124 54.0815 21.8116 54.0815 23.177C54.0815 24.5423 52.9823 25.6415 51.617 25.6415H11.3844C10.0191 25.6415 8.91992 24.5423 8.91992 23.177C8.91992 21.8116 10.0191 20.7124 11.3844 20.7124Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8028 28.1804C40.5661 28.1804 42.8063 25.9403 42.8063 23.1769C42.8063 20.4135 40.5661 18.1733 37.8028 18.1733C35.0394 18.1733 32.7992 20.4135 32.7992 23.1769C32.7992 25.9403 35.0394 28.1804 37.8028 28.1804Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1535 45.5488C28.9169 45.5488 31.157 43.3087 31.157 40.5453C31.157 37.7819 28.9169 35.5417 26.1535 35.5417C23.3901 35.5417 21.1499 37.7819 21.1499 40.5453C21.1499 43.3087 23.3901 45.5488 26.1535 45.5488Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88371 36.2197H50.1163C51.4816 36.2197 52.5808 37.3189 52.5808 38.6843C52.5808 40.0496 51.4816 41.1489 50.1163 41.1489H9.88371C8.51837 41.1489 7.41919 40.0496 7.41919 38.6843C7.41919 37.3189 8.51837 36.2197 9.88371 36.2197Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88371 36.2197H22.6163C23.9816 36.2197 25.0808 37.3189 25.0808 38.6843C25.0808 40.0496 23.9816 41.1489 22.6163 41.1489H9.88371C8.51837 41.1489 7.41919 40.0496 7.41919 38.6843C7.41919 37.3189 8.51837 36.2197 9.88371 36.2197Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88371 18.8513H50.1163C51.4816 18.8513 52.5808 19.9505 52.5808 21.3159C52.5808 22.6812 51.4816 23.7805 50.1163 23.7805H9.88371C8.51837 23.7805 7.41919 22.6812 7.41919 21.3159C7.41919 19.9505 8.51837 18.8513 9.88371 18.8513Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.302 26.3193C39.0654 26.3193 41.3056 24.0792 41.3056 21.3158C41.3056 18.5524 39.0654 16.3123 36.302 16.3123C33.5386 16.3123 31.2985 18.5524 31.2985 21.3158C31.2985 24.0792 33.5386 26.3193 36.302 26.3193Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88371 18.8513H32.6163C33.9816 18.8513 35.0808 19.9505 35.0808 21.3159C35.0808 22.6812 33.9816 23.7805 32.6163 23.7805H9.88371C8.51837 23.7805 7.41919 22.6812 7.41919 21.3159C7.41919 19.9505 8.51837 18.8513 9.88371 18.8513Z",
    fill: "#006363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6527 43.6877C27.4161 43.6877 29.6563 41.4476 29.6563 38.6842C29.6563 35.9208 27.4161 33.6807 24.6527 33.6807C21.8893 33.6807 19.6492 35.9208 19.6492 38.6842C19.6492 41.4476 21.8893 43.6877 24.6527 43.6877Z",
    fill: "#006363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_39900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesWizard);
export default __webpack_public_path__ + "static/media/preferences-wizard.e48baaaab2535aa6c2cbd0eea20bc676.svg";
export { ForwardRef as ReactComponent };